import { render, staticRenderFns } from "./EmployeeSourceSalary.vue?vue&type=template&id=672595ea&"
import script from "./EmployeeSourceSalary.vue?vue&type=script&lang=js&"
export * from "./EmployeeSourceSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports